import { FilterOutlined } from '@ant-design/icons';
import { Button, Popover, Radio, RadioChangeEvent, Space } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ComponentsDispatch, RootState } from '../store';
import { setterCalendar } from '../store/slices/calendarSlice';
import { HeaderType } from '../types';

const options: { label: string; value: HeaderType }[] = [
    { label: 'Day', value: 'day' },
    { label: 'Week', value: 'week' },
    { label: 'Month', value: 'month' },
    { label: 'Year', value: 'year' },
    { label: 'Quarter', value: 'quarter' },
];

const CalendarAgendaFilter = () => {
    const dispatch = useDispatch<ComponentsDispatch>();

    const agendaFilter = useSelector<RootState, HeaderType>((state) => state.calendar.agendaFilter);
    const onChange = (event: RadioChangeEvent) => {
        dispatch(setterCalendar({ agendaFilter: event.target.value as HeaderType }));
    };

    const content = (
        <Radio.Group onChange={onChange} value={agendaFilter}>
            <Space direction="vertical">
                {options.map((option) => (
                    <Radio key={option.value} value={option.value}>
                        {option.label}
                    </Radio>
                ))}
            </Space>
        </Radio.Group>
    );

    return (
        <div style={{ position: 'absolute', top: 20, right: 10 }}>
            <Popover content={content} title="Agenda Filter:" placement="bottomRight" style={{ width: 50 }}>
                <Button shape="circle" icon={<FilterOutlined />} size={'large'} />
            </Popover>
        </div>
    );
};

export default CalendarAgendaFilter;
